import type { Page } from 'redesign/components/organisms/Tabs/types'
import type { EventTimelineT } from 'types/cms'

export const EVENT_TABS = {
  past: 'past',
  upcoming: 'upcoming',
}

export const PAGES: Page[] = [
  {
    name: EVENT_TABS.past,
    label: 'page.cms.event.filterPast',
  },
  {
    name: EVENT_TABS.upcoming,
    label: 'page.cms.event.filterUpcoming',
  },
]

export const EVENT_TAB_TO_TIMELINE: Record<(typeof EVENT_TABS)[keyof typeof EVENT_TABS], EventTimelineT> = {
  [EVENT_TABS.past]: 'PAST',
  [EVENT_TABS.upcoming]: 'UPCOMING',
}
